
import React, { Component } from "react";
import axios from "axios";
import config from "../../config.json";
import AuthService from "../../services/authService";

import {
    Box,
    Button,
    Container,
    Paper,
    TextField,
    Typography,
} from "@mui/material";

import { Formik } from "formik";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";

class LoginPage extends Component {
    apiEndPoint = config.apiEndPoint + "users/login";
    recaptchaRef = React.createRef();

    schema = Yup.object().shape({
        username: Yup.string()
            .required("Username is required")
            .min(4)
            .max(15),

        password: Yup.string()
            .required("Password is required")
            .min(4)
            .max(15),
    });

    async doSubmit(values, captchaResponse) {
        return axios
            .post(this.apiEndPoint, {
                ...values,
                captchaResponse,
            })
            .then((r) => r.data)
            .then((result) => {
                const token = result?.jwt;

                if (!token) {
                    toast.error("Login failed.");
                    return;
                }

                AuthService.storeJWT(token);
                toast.success("Welcome back, warrior.");

                setTimeout(() => (window.location = "/"), 1200);
            })
            .catch((ex) => {
                toast.error(ex?.response?.data || "Error occurred");
                this.recaptchaRef.current?.reset();
            });
    }

    render() {
        return (
            <Box
                sx={{
                    minHeight: "100vh",
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    background:
                        "radial-gradient(circle at 50% -10%, rgba(255,70,25,0.16), transparent 36%), radial-gradient(circle at 0% 100%, rgba(190,35,10,0.10), transparent 32%), radial-gradient(circle at 100% 45%, rgba(255,100,35,0.055), transparent 30%), linear-gradient(180deg, #020202 0%, #080706 50%, #020202 100%)",

                    px: 2,
                    py: { xs: 5, md: 8 },

                    "&:before": {
                        content: '""',
                        position: "absolute",
                        inset: 0,
                        pointerEvents: "none",
                        opacity: 0.16,
                        backgroundImage:
                            "linear-gradient(rgba(255,70,25,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(255,70,25,0.08) 1px, transparent 1px)",
                        backgroundSize: "45px 45px",
                    },

                    "&:after": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "65%",
                        height: "1px",
                        background:
                            "linear-gradient(90deg, transparent, rgba(255,70,25,0.9), rgba(255,145,70,0.75), rgba(255,70,25,0.9), transparent)",
                        boxShadow:
                            "0 0 25px rgba(255,65,20,0.45)",
                    },
                }}
            >
                {/* =====================================================
                    TOP FIRE GLOW
                ====================================================== */}
                <Box
                    sx={{
                        position: "absolute",
                        top: -280,
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: 750,
                        height: 560,
                        borderRadius: "50%",
                        background:
                            "radial-gradient(circle, rgba(255,65,20,0.17) 0%, rgba(180,30,8,0.05) 40%, transparent 72%)",
                        filter: "blur(90px)",
                        pointerEvents: "none",
                    }}
                />

                {/* =====================================================
                    LEFT EMBER GLOW
                ====================================================== */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "25%",
                        left: -270,
                        width: 550,
                        height: 550,
                        borderRadius: "50%",
                        background:
                            "radial-gradient(circle, rgba(220,45,12,0.10) 0%, transparent 70%)",
                        filter: "blur(100px)",
                        pointerEvents: "none",
                    }}
                />

                {/* =====================================================
                    RIGHT EMBER GLOW
                ====================================================== */}
                <Box
                    sx={{
                        position: "absolute",
                        bottom: -280,
                        right: -260,
                        width: 600,
                        height: 600,
                        borderRadius: "50%",
                        background:
                            "radial-gradient(circle, rgba(255,80,25,0.11) 0%, transparent 70%)",
                        filter: "blur(105px)",
                        pointerEvents: "none",
                    }}
                />

                {/* =====================================================
                    DECORATIVE SIDE LINES
                ====================================================== */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "22%",
                        left: 0,
                        width: { xs: "18%", md: "30%" },
                        height: "1px",
                        background:
                            "linear-gradient(90deg, transparent, rgba(255,70,25,0.35), transparent)",
                        pointerEvents: "none",
                    }}
                />

                <Box
                    sx={{
                        position: "absolute",
                        bottom: "22%",
                        right: 0,
                        width: { xs: "18%", md: "30%" },
                        height: "1px",
                        background:
                            "linear-gradient(90deg, transparent, rgba(255,70,25,0.35), transparent)",
                        pointerEvents: "none",
                    }}
                />

                <Container
                    maxWidth="sm"
                    sx={{
                        position: "relative",
                        zIndex: 2,
                    }}
                >
                    {/* =================================================
                        PAGE BRANDING
                    ================================================== */}
                    <Box
                        sx={{
                            textAlign: "center",
                            mb: 3,
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#ff7135",
                                fontSize: "9px",
                                fontWeight: 900,
                                letterSpacing: "4px",
                                mb: 1,
                                textShadow:
                                    "0 0 16px rgba(255,70,25,0.35)",
                            }}
                        >
                            VEX CONQUER • CLASSIC 5165
                        </Typography>

                        <Typography
                            sx={{
                                color:
                                    "rgba(255,255,255,0.30)",
                                fontSize: "10px",
                                letterSpacing: "1.5px",
                            }}
                        >
                            RETURN TO THE BATTLEFIELD
                        </Typography>
                    </Box>

                    <Formik
                        validationSchema={this.schema}
                        initialValues={{
                            username: "",
                            password: "",
                        }}
                        onSubmit={(values) =>
                            this.doSubmit(
                                values,
                                this.recaptchaRef.current?.getValue()
                            )
                        }
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                        }) => (
                            <Paper
                                elevation={0}
                                sx={{
                                    position: "relative",
                                    overflow: "hidden",
                                    borderRadius: {
                                        xs: "20px",
                                        sm: "28px",
                                    },

                                    background:
                                        "linear-gradient(145deg, #120c0a 0%, #090807 52%, #030303 100%)",

                                    border:
                                        "1px solid rgba(255,75,30,0.20)",

                                    boxShadow:
                                        "0 35px 110px rgba(0,0,0,0.78), 0 0 70px rgba(180,35,10,0.08), inset 0 1px 0 rgba(255,255,255,0.025)",

                                    "&:before": {
                                        content: '""',
                                        position: "absolute",
                                        top: 0,
                                        left: "7%",
                                        right: "7%",
                                        height: "2px",
                                        background:
                                            "linear-gradient(90deg, transparent, #d92d0c, #ff7135, #ff9a4d, #d92d0c, transparent)",
                                        boxShadow:
                                            "0 0 20px rgba(255,65,20,0.55)",
                                    },

                                    "&:after": {
                                        content: '""',
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                        width: 220,
                                        height: 220,
                                        background:
                                            "radial-gradient(circle, rgba(255,65,20,0.075), transparent 70%)",
                                        pointerEvents: "none",
                                    },
                                }}
                            >
                                {/* =================================================
                                    HEADER
                                ================================================== */}
                                <Box
                                    sx={{
                                        position: "relative",
                                        px: {
                                            xs: 3,
                                            md: 5,
                                        },
                                        pt: {
                                            xs: 4.5,
                                            md: 5.5,
                                        },
                                        pb: 4,
                                        textAlign: "center",
                                        overflow: "hidden",

                                        background:
                                            "linear-gradient(145deg, rgba(255,65,20,0.06), rgba(8,8,8,0.80))",
                                    }}
                                >
                                    {/* HEADER GLOW */}
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: -160,
                                            left: "50%",
                                            transform:
                                                "translateX(-50%)",
                                            width: 450,
                                            height: 340,
                                            borderRadius: "50%",
                                            background:
                                                "radial-gradient(circle, rgba(255,65,20,0.18), transparent 70%)",
                                            filter: "blur(75px)",
                                            pointerEvents:
                                                "none",
                                        }}
                                    />

                                    {/* VEX MARK */}
                                    <Box
                                        sx={{
                                            position: "relative",
                                            width: {
                                                xs: 88,
                                                md: 100,
                                            },
                                            height: {
                                                xs: 88,
                                                md: 100,
                                            },
                                            mx: "auto",
                                            mb: 2.8,
                                            borderRadius:
                                                "26px",

                                            display: "flex",
                                            alignItems:
                                                "center",
                                            justifyContent:
                                                "center",

                                            background:
                                                "linear-gradient(145deg, #ff7135 0%, #d72f0c 48%, #821b0a 100%)",

                                            border:
                                                "1px solid rgba(255,160,100,0.25)",

                                            boxShadow:
                                                "0 18px 55px rgba(215,45,12,0.28), 0 0 35px rgba(255,65,20,0.13), inset 0 1px 0 rgba(255,255,255,0.25)",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 68,
                                                height: 68,
                                                borderRadius:
                                                    "18px",

                                                display: "flex",
                                                alignItems:
                                                    "center",
                                                justifyContent:
                                                    "center",

                                                border:
                                                    "1px solid rgba(255,255,255,0.22)",

                                                background:
                                                    "rgba(0,0,0,0.18)",

                                                boxShadow:
                                                    "inset 0 0 20px rgba(0,0,0,0.22)",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    color: "#fff",
                                                    fontWeight: 1000,
                                                    fontSize: {
                                                        xs: "26px",
                                                        md: "30px",
                                                    },
                                                    letterSpacing:
                                                        "-2px",
                                                    lineHeight: 1,
                                                    textShadow:
                                                        "0 2px 8px rgba(0,0,0,0.45)",
                                                }}
                                            >
                                                VX
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* LABEL */}
                                    <Typography
                                        sx={{
                                            position:
                                                "relative",
                                            color: "#ff7135",
                                            fontSize: "10px",
                                            fontWeight: 900,
                                            letterSpacing:
                                                "4px",
                                            mb: 1.5,
                                            textTransform:
                                                "uppercase",
                                        }}
                                    >
                                        WELCOME WARRIOR
                                    </Typography>

                                    {/* TITLE */}
                                    <Typography
                                        sx={{
                                            position:
                                                "relative",
                                            color: "#fff",
                                            fontWeight: 900,
                                            fontSize: {
                                                xs: "37px",
                                                md: "48px",
                                            },
                                            lineHeight: 1,
                                            letterSpacing:
                                                "-1.5px",
                                        }}
                                    >
                                        WELCOME{" "}
                                        <span
                                            style={{
                                                color: "#ff7135",
                                            }}
                                        >
                                            BACK
                                        </span>
                                    </Typography>

                                    <Typography
                                        sx={{
                                            position:
                                                "relative",
                                            color:
                                                "rgba(255,255,255,0.45)",
                                            mt: 1.8,
                                            fontSize: "13px",
                                            lineHeight: 1.8,
                                        }}
                                    >
                                        Your warrior is waiting.
                                        <br />
                                        Enter the realm and return
                                        to battle.
                                    </Typography>

                                    {/* SERVER TAGS */}
                                    <Box
                                        sx={{
                                            position:
                                                "relative",
                                            display: "flex",
                                            justifyContent:
                                                "center",
                                            flexWrap:
                                                "wrap",
                                            gap: 1,
                                            mt: 2.5,
                                        }}
                                    >
                                        {[
                                            "5165 CLASSIC",
                                            "LEVEL 130",
                                            "1ST REBORN",
                                            "CLASSIC PVP",
                                        ].map(
                                            (item) => (
                                                <Box
                                                    key={
                                                        item
                                                    }
                                                    sx={{
                                                        px: 1.4,
                                                        py: 0.6,
                                                        borderRadius:
                                                            "6px",
                                                        background:
                                                            "rgba(255,65,20,0.045)",
                                                        border:
                                                            "1px solid rgba(255,75,30,0.12)",
                                                        color:
                                                            "rgba(255,255,255,0.48)",
                                                        fontSize:
                                                            "8px",
                                                        fontWeight:
                                                            800,
                                                        letterSpacing:
                                                            "0.8px",
                                                    }}
                                                >
                                                    {item}
                                                </Box>
                                            )
                                        )}
                                    </Box>
                                </Box>

                                {/* DIVIDER */}
                                <Box
                                    sx={{
                                        mx: {
                                            xs: 3,
                                            md: 5,
                                        },
                                        height: "1px",
                                        background:
                                            "linear-gradient(90deg, transparent, rgba(255,70,25,0.28), transparent)",
                                    }}
                                />

                                {/* =================================================
                                    FORM
                                ================================================== */}
                                <Box
                                    sx={{
                                        p: {
                                            xs: 3,
                                            md: 5,
                                        },
                                    }}
                                >
                                    <form
                                        onSubmit={
                                            handleSubmit
                                        }
                                    >
                                        {/* FORM LABEL */}
                                        <Box
                                            sx={{
                                                display:
                                                    "flex",
                                                alignItems:
                                                    "center",
                                                gap: 1.5,
                                                mb: 2.5,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 4,
                                                    height: 23,
                                                    borderRadius:
                                                        "10px",
                                                    background:
                                                        "linear-gradient(180deg, #ff7135, #b5220b)",
                                                    boxShadow:
                                                        "0 0 14px rgba(255,65,20,0.45)",
                                                }}
                                            />

                                            <Box>
                                                <Typography
                                                    sx={{
                                                        color:
                                                            "#fff",
                                                        fontSize:
                                                            "14px",
                                                        fontWeight:
                                                            900,
                                                        lineHeight:
                                                            1.2,
                                                    }}
                                                >
                                                    PLAYER
                                                    LOGIN
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        color:
                                                            "rgba(255,255,255,0.28)",
                                                        fontSize:
                                                            "8px",
                                                        fontWeight:
                                                            700,
                                                        letterSpacing:
                                                            "1px",
                                                        mt: 0.5,
                                                    }}
                                                >
                                                    ACCESS YOUR
                                                    WARRIOR
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* USERNAME */}
                                        <TextField
                                            fullWidth
                                            name="username"
                                            label="Username"
                                            value={
                                                values.username
                                            }
                                            onChange={
                                                handleChange
                                            }
                                            onBlur={
                                                handleBlur
                                            }
                                            sx={{
                                                mb: 1,
                                                ...fieldStyle,
                                            }}
                                        />

                                        {errors.username &&
                                            touched.username && (
                                                <Typography
                                                    sx={{
                                                        color:
                                                            "#ff5c5c",
                                                        fontSize:
                                                            "11px",
                                                        mt: 0.8,
                                                        mb: 1.5,
                                                        pl: 1,
                                                        fontWeight:
                                                            600,
                                                    }}
                                                >
                                                    {
                                                        errors.username
                                                    }
                                                </Typography>
                                            )}

                                        {/* PASSWORD */}
                                        <TextField
                                            fullWidth
                                            type="password"
                                            name="password"
                                            label="Password"
                                            value={
                                                values.password
                                            }
                                            onChange={
                                                handleChange
                                            }
                                            onBlur={
                                                handleBlur
                                            }
                                            sx={{
                                                mt:
                                                    errors.username &&
                                                    touched.username
                                                        ? 0
                                                        : 2.5,
                                                mb: 1,
                                                ...fieldStyle,
                                            }}
                                        />

                                        {errors.password &&
                                            touched.password && (
                                                <Typography
                                                    sx={{
                                                        color:
                                                            "#ff5c5c",
                                                        fontSize:
                                                            "11px",
                                                        mt: 0.8,
                                                        mb: 1.5,
                                                        pl: 1,
                                                        fontWeight:
                                                            600,
                                                    }}
                                                >
                                                    {
                                                        errors.password
                                                    }
                                                </Typography>
                                            )}

                                        {/* LOGIN INFO */}
                                        <Box
                                            sx={{
                                                display:
                                                    "flex",
                                                justifyContent:
                                                    "space-between",
                                                alignItems:
                                                    "center",
                                                mt: 1.5,
                                                mb: 1,
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    color:
                                                        "rgba(255,255,255,0.24)",
                                                    fontSize:
                                                        "9px",
                                                    letterSpacing:
                                                        "0.5px",
                                                }}
                                            >
                                                VEX CONQUER
                                                ACCOUNT
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color:
                                                        "rgba(255,113,53,0.65)",
                                                    fontSize:
                                                        "9px",
                                                    fontWeight:
                                                        800,
                                                }}
                                            >
                                                5165 CLASSIC
                                            </Typography>
                                        </Box>

                                        {/* CAPTCHA */}
                                        <Box
                                            sx={{
                                                display:
                                                    "flex",
                                                justifyContent:
                                                    "center",
                                                mt: 3,
                                                mb: 3.5,
                                                p: 1.5,
                                                borderRadius:
                                                    "13px",
                                                background:
                                                    "linear-gradient(145deg, rgba(255,255,255,0.025), rgba(255,65,20,0.015))",
                                                border:
                                                    "1px solid rgba(255,75,30,0.08)",
                                                overflow:
                                                    "hidden",
                                                "& > div": {
                                                    maxWidth:
                                                        "100%",
                                                },
                                            }}
                                        >
                                            <ReCAPTCHA
                                                ref={
                                                    this
                                                        .recaptchaRef
                                                }
                                                sitekey={
                                                    config.RECAPTCHA_SITE_KEY
                                                }
                                            />
                                        </Box>

                                        {/* LOGIN BUTTON */}
                                        <Button
                                            type="submit"
                                            fullWidth
                                            sx={{
                                                position:
                                                    "relative",
                                                py: 1.75,
                                                borderRadius:
                                                    "13px",

                                                fontWeight:
                                                    900,
                                                fontSize:
                                                    "14px",
                                                letterSpacing:
                                                    "1.5px",
                                                textTransform:
                                                    "uppercase",

                                                background:
                                                    "linear-gradient(135deg, #ff7135 0%, #e13b13 48%, #98210b 100%)",

                                                color: "#fff",

                                                border:
                                                    "1px solid rgba(255,145,95,0.20)",

                                                boxShadow:
                                                    "0 13px 35px rgba(210,45,12,0.23), 0 0 25px rgba(255,65,20,0.08), inset 0 1px 0 rgba(255,255,255,0.22)",

                                                transition:
                                                    "all 0.25s ease",

                                                "&:hover": {
                                                    background:
                                                        "linear-gradient(135deg, #ff8a55 0%, #f04b1b 48%, #b72a10 100%)",

                                                    boxShadow:
                                                        "0 17px 42px rgba(220,50,15,0.34), 0 0 30px rgba(255,65,20,0.13)",

                                                    transform:
                                                        "translateY(-2px)",
                                                },

                                                "&:active": {
                                                    transform:
                                                        "translateY(0)",
                                                },
                                            }}
                                        >
                                            ⚔ ENTER THE REALM
                                        </Button>

                                        {/* REGISTER */}
                                        <Typography
                                            sx={{
                                                textAlign:
                                                    "center",
                                                mt: 3.5,
                                                color:
                                                    "rgba(255,255,255,0.40)",
                                                fontSize:
                                                    "12px",
                                            }}
                                        >
                                            New warrior?{" "}
                                            <a
                                                href="/user/register"
                                                style={{
                                                    color:
                                                        "#ff7135",
                                                    fontWeight:
                                                        900,
                                                    textDecoration:
                                                        "none",
                                                }}
                                            >
                                                CREATE ACCOUNT
                                            </a>
                                        </Typography>
                                    </form>
                                </Box>

                                {/* =================================================
                                    SERVER INFO
                                ================================================== */}
                                <Box
                                    sx={{
                                        display:
                                            "grid",
                                        gridTemplateColumns:
                                            "repeat(3, 1fr)",
                                        borderTop:
                                            "1px solid rgba(255,255,255,0.045)",
                                        background:
                                            "rgba(0,0,0,0.22)",
                                    }}
                                >
                                    <InfoCell
                                        title="5165"
                                        subtitle="CLASSIC CORE"
                                    />

                                    <InfoCell
                                        title="130"
                                        subtitle="MAX LEVEL"
                                    />

                                    <InfoCell
                                        title="PVP"
                                        subtitle="CLASSIC BATTLES"
                                    />
                                </Box>

                                {/* =================================================
                                    BOTTOM BRANDING
                                ================================================== */}
                                <Box
                                    sx={{
                                        px: 3,
                                        py: 2.3,
                                        textAlign:
                                            "center",
                                        borderTop:
                                            "1px solid rgba(255,255,255,0.035)",
                                        background:
                                            "rgba(0,0,0,0.28)",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color:
                                                "rgba(255,255,255,0.22)",
                                            fontSize:
                                                "9px",
                                            fontWeight:
                                                800,
                                            letterSpacing:
                                                "2.5px",
                                            textTransform:
                                                "uppercase",
                                        }}
                                    >
                                        VEX • 5165 VERSION 1.0 • CLASSIC CONQUER
                                    </Typography>
                                </Box>
                            </Paper>
                        )}
                    </Formik>

                    {/* =================================================
                        BOTTOM MESSAGE
                    ================================================== */}
                    <Box
                        sx={{
                            textAlign: "center",
                            mt: 3,
                        }}
                    >
                        <Typography
                            sx={{
                                color:
                                    "rgba(255,255,255,0.20)",
                                fontSize: "9px",
                                letterSpacing:
                                    "2px",
                                fontWeight: 700,
                            }}
                        >
                            YOUR WARRIOR • YOUR GUILD • YOUR LEGACY
                        </Typography>
                    </Box>
                </Container>
            </Box>
        );
    }
}

/* =========================================================
   LOGIN FIELD STYLE
========================================================= */

const fieldStyle = {
    "& .MuiOutlinedInput-root": {
        minHeight: 55,

        color: "#fff",

        borderRadius: "13px",

        background:
            "linear-gradient(145deg, rgba(255,255,255,0.035), rgba(255,255,255,0.012))",

        transition: "all 0.25s ease",

        "& fieldset": {
            borderColor:
                "rgba(255,75,30,0.13)",
        },

        "&:hover": {
            background:
                "linear-gradient(145deg, rgba(255,70,25,0.045), rgba(255,255,255,0.018))",

            "& fieldset": {
                borderColor:
                    "rgba(255,80,35,0.38)",
            },
        },

        "&.Mui-focused": {
            background:
                "rgba(255,65,20,0.035)",

            "& fieldset": {
                borderColor: "#ff7135",
                borderWidth: "1px",
            },
        },
    },

    "& .MuiInputLabel-root": {
        color:
            "rgba(255,255,255,0.43)",
        fontSize: "13px",

        "&.Mui-focused": {
            color: "#ff7135",
        },
    },

    "& .MuiInputLabel-shrink": {
        background: "#0c0908",
        padding: "0 5px",
    },

    "& input": {
        color: "#fff",
        fontSize: "13px",
        padding: "17px 14px",
    },
};

/* =========================================================
   INFO CELL
========================================================= */

const InfoCell = ({ title, subtitle }) => (
    <Box
        sx={{
            textAlign: "center",
            py: 2,

            borderRight:
                "1px solid rgba(255,255,255,0.035)",

            "&:last-child": {
                borderRight: "none",
            },
        }}
    >
        <Typography
            sx={{
                color: "#ff7135",
                fontWeight: 900,
                fontSize: "15px",
                lineHeight: 1,

                textShadow:
                    "0 0 12px rgba(255,65,20,0.30)",
            }}
        >
            {title}
        </Typography>

        <Typography
            sx={{
                color:
                    "rgba(255,255,255,0.24)",
                fontSize: "7px",
                fontWeight: 800,
                letterSpacing: "1px",
                mt: 0.7,
            }}
        >
            {subtitle}
        </Typography>
    </Box>
);

export default LoginPage;

